import {  Auth } from "aws-amplify";
import classNames from "classnames";
import React from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import API from "../api/api.main"

function FootageCompleteAllRequest({ selectedRows, setSelectedRows, refetch, formQuery }) {
  const { user } = useSelector((state) => state.initializeApp);

  const onClickCompleteSelected = async () => {
    try {
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะทำรายการหรือไม่?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          for (const row of selectedRows) {
            const { original } = row;
            await API.put(
              "MoneyHubAdmin",
              `/leasing/requestStatus/${original.request_id}`,
              {
                body: {
                  fileBuro: "",
                  reason: "",
                  new_loan_status: "อนุมัติ",
                  referal_one: original?.referal_one,
                  referal_two: original?.referal_two,
                  adminName: user.username,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              }
            );
          }
        },
      });
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await refetch(formQuery);
      setSelectedRows([])
    } catch (error) {
      await Swal.fire({
        title: "ERROR",
        text: "อัพเดตข้อมูลไม่สำเร็จ",
        icon: "error",
        confirmButtonText: "ยืนยัน",
      });
      return console.log("Update error :", error);
    }
  };

  if (!user?.groups?.some((group) => ["SuperAdmin"].includes(group))) {
    return null;
  }

  return (
    <button
      disabled={!selectedRows.length}
      className={classNames(
        " border p-1 px-2 mr-1 rounded  duration-300 hover:text-white",
        {
          "bg-gray-300 cursor-not-allowed text-white": !selectedRows.length,
          "border-green-500 p-1 px-2 rounded text-green-500 hover:bg-green-600 hover:text-white":
            selectedRows.length,
        }
      )}
      onClick={onClickCompleteSelected}
    >
      Complete All
    </button>
  );
}

export default FootageCompleteAllRequest;
